import "./styles.css";

const Page = ({
  containerClassName,
  bodyClassName,
  header = null,
  footer = null,
  children,
}) => {
  return (
    <div className={`page-container ${containerClassName}`}>
      {header}
      <div className={`page-body ${bodyClassName}`}>{children}</div>
      {footer}
    </div>
  );
};

export default Page;
